const attributeComponents = [
    'Align', 'BackgroundColor', 'Light', 'LightOne', 'LightTwo', 'LabelType',
    'LightThree', 'Size', 'Strong', 'ShowAudio', 'ShowPinyin', 'ShowTranslation',
    'FullScreen', 'Tags', 'SubImage', 'Position', 'Color'
];
const elementMixin = {
    props: {
        value: Object,
        sign: String,
    },
    data() {
        return {
            detail: null,
            data: null,
            attributes: [],
            availableAttributes: [],
        }
    },
    watch: {
        attributes(newVal, oldVal) {},
        data(newVal, oldVal) {},
        sign(newVal, oldVal) {
            this.init();
        },
    },
    created() {},
    mounted() {
        this.init();
        this.initSelf();
    },
    methods: {
        initSelf() {
            // 这个方法由实例实现
        },
        // 初始化
        init() {
            this.detail = this.value;
            this.data = this.detail.data;
            this.attributes = this.detail.attributes;
            this.initAvailableAttributes();
            this.initData();
            this.initAttributes();
        },
        // 初始化属性组件
        initAvailableAttributes() {
            for (var i in this.$options.components) {
                for (var j in attributeComponents) {
                    if (attributeComponents[j] == i) {
                        var c = { type: i, checked: false, value: null };
                        for (var k in this.attributes) {
                            if (this.attributes[k].type == i) {
                                c = Object.assign(c, this.attributes[k]); //合并额外参数
                            }
                        }
                        this.availableAttributes.push(c);
                    }
                }
            }
        },
        // 初始化数据
        initData() {
            if (this.data == null) {
                this.data = this.default;
            }
        },
        // 初始化属性
        initAttributes() {
            for (var j in this.availableAttributes) {
                var b = this.availableAttributes[j];
                for (var i in this.attributes) {
                    var a = this.attributes[i];
                    if (b.type == a.type) {
                        b.checked = a.checked;
                        b.value = a.value;
                    }
                }
            }
            this.attributes = this.availableAttributes;
        },
        // 保存属性:新增,修改,删除
        saveAttr(data, type) {
            if (this.attributes.length == 0) {
                this.attributes.push(data);
                return true;
            }
            var matched = false
            for (var i in this.attributes) {
                if (this.attributes[i].type == type) {
                    matched = true;
                    if (data == null) {
                        this.attributes.splice(i, 1);
                        break
                    }
                    this.attributes[i] = data;
                }
            }
            if (matched == false) {
                this.attributes.push(data);
            }
        },
        // 合并数据,准备提交
        mergeData() {
            if (!this.emptyData()) {
                this.detail.data = this.data;
            }
            this.detail.attributes = this.attributes;
        },
        // 提交
        submit() {
            this.mergeData();
            this.$emit('input', this.detail);
            this.close();
        },
        // 关闭当前窗口
        close() {
            this.$emit('closeComponent');
        },
    }
};
export default elementMixin;